// extracted by mini-css-extract-plugin
export default {"container":"CurrentPage_container__MsNjK","currentPage":"CurrentPage_currentPage__-Ads-"};